import * as utils from '@daas-consulting/core-frontend-utils';
import { FullFilters } from '../models';

export type FormatCallback = (
  filterKey: string,
  attrKey: string | null,
  value: unknown
) => unknown;

export function getFilterAsQuerystring(
  { filters, pageIndex, pageSize, order }: FullFilters,
  formatCallback: FormatCallback = noopFormat
): Map<string, unknown> {
  const rv = new Map<string, unknown>();
  rv.set('pageIndex', pageIndex);
  rv.set('pageSize', pageSize);
  if (Array.isArray(order) && order.length > 0) {
    const sort = order.map((x) => `${x.field} ${x.type}`).join(',');
    rv.set('sort', sort);
  }

  if (Array.isArray(filters)) {
    filters.forEach((filter) => {
      if (Array.isArray(filter.attributes)) {
        filter.attributes.forEach((attr) => {
          set({
            storage: rv,
            mapKey: attr.key,
            value: attr.rawValue,
            filterKey: filter.key,
            attrKey: attr.key,
            formatCallback,
          });
        });
      } else {
        set({
          storage: rv,
          mapKey: filter.key,
          value: filter.rawValue,
          filterKey: filter.key,
          attrKey: null,
          formatCallback,
        });
      }
    });
  }

  return rv;
}

interface SetOptions {
  storage: Map<string, unknown>;
  mapKey: string;
  value: unknown;
  filterKey: string;
  attrKey: string | null;
  formatCallback: FormatCallback;
}

function set({
  storage,
  mapKey,
  value,
  filterKey,
  attrKey,
  formatCallback = noopFormat,
}: SetOptions): void {
  if (Array.isArray(value)) {
    const formattedValue = value.map((item) => {
      const serializedItem = utils.serialize.serializeToUrl(item);
      return formatCallback(filterKey, attrKey, serializedItem);
    });
    storage.set(mapKey, formattedValue);
    return;
  }

  const serializedValue = utils.serialize.serializeToUrl(value);
  const formattedValue = formatCallback(filterKey, attrKey, serializedValue);
  storage.set(mapKey, formattedValue);
}

export function noopFormat(
  filterKey: string,
  attrKey: string | null,
  value: unknown
): unknown {
  return value;
}

export function datetimeToDateFormat(
  filterKey: string,
  attrKey: string | null,
  value: unknown
): unknown {
  const rv = `${value}`.replace(
    /T(?:\d{2}):(?:\d{2}):(?:\d{2}).(?:\d{3})Z/gi,
    ''
  );
  return rv;
}
